<template>
  <div
    class="oct-section-header"
    :class="{
      'oct-section-header--separated': separate,
      'oct-section-header--dense': dense
    }"
  >
    <h2 class="oct-section-header__primary-text">{{ title }}</h2>
    
    <component
      :is="meta.href === '' ? 'span' : 'a'"
      class="oct-section-header__meta"
      :href="meta.href === '' ? false : meta.href"
    >
      <span class="oct-section-header__meta-text">{{ meta.text }}</span>
    </component>
  </div>
</template>

<script>
export default {
  name: 'OctArticleHeader',
  props: {
    /** Title Text */
    title: {
      type: String,
      default: ''
    },
    /** Meta */
    meta: {
      type: Object,
      default () {
        return {
          text: '',
          href: ''
        }
      }
    },
    /** Whether header needs border */
    separate: {
      type: Boolean,
      default: true
    },
    /** Whether small */
    dense: {
      type: Boolean,
      default: true
    }
  }
}
</script>

<style scoped lang="scss">
@import "../theme/variables";
@import "../grid/variables";
@import "../typography/variables";
@import "../typography/mixins";

.oct-section-header {
  display: flex;
  justify-content: space-between;
  margin: 0 0 oct-rem(44);
  padding: oct-rem(14) 0 0;
  border-top: oct-rem(1) solid transparent;

  &--separated {
    border-color: $oct-theme--primary;
  }

  &--dense {
    margin: 0 0 oct-rem(39);
    padding: oct-rem(8) 0 0;
  }

@media screen and (min-width: map-get($grid-breakpoints, 'md')) {
  margin-bottom: oct-rem(78);

  &--dense {
    margin-bottom: oct-rem(94);
  }
}
}

.oct-section-header__primary-text {
  font-family: $font-family-sans-serif-ja-bold;
  font-size: oct-rem(21);
  font-weight: normal;
  line-height: (28/21);
  margin: (-5em/21) 0;

  .oct-section-header--dense & {
    font-family: $font-family-sans-serif;
    font-size: oct-rem(11);
    font-weight: normal;
    line-height: 1;
    margin: (-1em/11) 0;
  }

@media print, screen and (min-width: map-get($grid-breakpoints, 'md')) {
  .oct-section-header--dense & {
    font-size: oct-rem(13);
    line-height: (18/13);
    margin: (-4em/13) 0;
  }
}
}

.oct-section-header__meta {
  font-size: oct-rem(11);
  line-height: 1;
  text-decoration: none;
  color: $oct-theme--primary;
  margin: (-1em/11) 0;
  display: flex;

  .oct-icon__arrow-forward {
    margin-left: 3px;
    width: 12px;
    height: 12px;
    fill: $oct-theme--success;
  }

  &:hover {
    opacity: .7;
  }

@media print, screen and (min-width: map-get($grid-breakpoints, 'md')) {
  font-size: oct-rem(13);
  line-height: (18/13);
  margin: (-4em/13) 0;
}
}

a.oct-section-header__meta {
  text-decoration: underline;
  text-underline-offset: oct-rem(2);
}
</style>